import React from "react";
import {  useSelector } from "react-redux"
import { useValidateDepMotUsingCustOfc } from "../../../hooks/AGS";
import { depTypeIdKey } from "../../../util/NL_fieldPatterns";

const DepartureTransportMode=({saveData,onUpdate,renderForm,modeType,title,isImportShipment,fieldPattern,validateError})=>{


  const dataSource=useSelector((state)=>state.Shipment.transportation[modeType])
  const motValidationMsg=useValidateDepMotUsingCustOfc(dataSource.mot,validateError,fieldPattern)

  const typeIdError=useSelector((state)=>state.ValidationErrors.header?.[depTypeIdKey]?.msg)
  const isMotTypeIdVisible=["5","7"].includes(dataSource.mot)
  const OnMotChange=({value,description,...rest})=>{
    if(["5","7"].includes(value) && !isImportShipment){
               saveData({mot:value,typeId:" ",...rest})
               onUpdate({mot:value?.trim(),typeId:"",...rest})
   
      }
     
  else{
    saveData({mot:value,...rest})
    onUpdate({mot:value?.trim(),...rest})
    
  }
    }

   return renderForm && renderForm({
    title,
    modeType,
    hideFields:{transportId:true,type:true,nationality:true},
    disableFields:{typeId:isMotTypeIdVisible},
    errorInfo:{mot:motValidationMsg,typeId:typeIdError},
    saveData,
    validationMsg:<ul><li>if MOT is 5 or 7 MOT Type Identification will be disabled.</li></ul>,
     dataSource, 
     onUpdate,
     onMotChange:OnMotChange,
     fieldPattern,
     validateError
   })


}

export default React.memo(DepartureTransportMode)
